import angular from 'angular';
import autocompleteComponent from './category-autocomplete.component';

export default angular.module('common.autocomplete.category', [])
  .component('categoryAutocomplete', autocompleteComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/category/category-autocomplete.module.js